import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location-pin",
  "use": "location-pin-usage",
  "viewBox": "0 0 17.5 25.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.5 25.3\" id=\"location-pin\"><path d=\"M16.8 25.3H.7v-1.1h16.1v1.1zm-8-2l-.4-.5C8 22.5 0 13.4 0 8.7 0 3.9 3.9 0 8.8 0s8.8 3.9 8.8 8.7c0 4.7-8 13.7-8.3 14.1l-.5.5zM1.1 8.7c0 3.7 6 11 7.6 12.9 1.7-1.9 7.6-9.2 7.6-12.9 0-4.2-3.4-7.6-7.6-7.6S1.1 4.5 1.1 8.7zm7.7 4.1c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm0-7c-1.6 0-3 1.3-3 3 0 1.6 1.3 3 3 3s3-1.3 3-3c-.1-1.7-1.4-3-3-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol